import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleNewHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/people/new` URL — what the embedded app's add-people
 * catalog links to. It always forwards to the Hydra page.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the
 * `journeys` segment, so the resolver's bundle-aware branch can rebuild the
 * target from the bundle prefix when the `/workspaces/last` sentinel needs
 * resolving.
 */
function JourneysPeopleNewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleNewHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/new')({
  component: JourneysPeopleNewRoute,
});
